<div *ngIf="errors && errors.length"
     class="designer-invalid">
  <i class="icon icon-ic_fluent_error_circle_20_regular"></i>
  <div class="invalid-message-container">
    <span *ngFor="let error of errors"
          class="invalid-message">
      {{error}}
    </span>
  </div>
</div>

<div *ngIf="warnings && warnings.length"
     class="designer-warning">
  <i class="icon icon-ic_fluent_warning_20_regular"></i>
  <div class="warning-message-container">
    <span *ngFor="let warning of warnings"
          class="warning-message">
      {{warning}}
    </span>
  </div>
</div>